<template>
  <v-container>
    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>

    <UploadDialog :visible="showUploadDialog" @resultFullData="uploadFinish"/>

    <v-card>
      <v-card-title>
        <h1>設定撥款資料 </h1>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.displayId" label="案件編號" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-btn color="primary" dark text :loading="loading" @click="searchEvent()">查詢</v-btn>
          </v-flex>
        </v-layout>

        <div v-if="itemDetail">
          <v-layout>
            <v-flex md6 xs6>
              <h2>案件類別: {{findCategory(itemDetail.promotionNo, itemDetail.promotionType)}}</h2>
            </v-flex >
            <v-flex md6 xs6>
              <span class="headline" style="color: red;">案件狀態：{{ findStatus(itemDetail.caseStatus) }}</span>
            </v-flex>
          </v-layout>
          <v-layout v-if="itemDetail.caseStatus === 3">
            <v-flex md6 xs6 >
              <h2>核准金額: {{itemDetail.totalPrice}}</h2>
            </v-flex >
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>內扣</h3>
              <v-text-field v-model="item.beforePrice" label="內扣" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <h3>前佣</h3>
              <v-text-field v-model="item.beforeBonus" label="前佣" outline></v-text-field>
            </v-flex >
          </v-layout>
<!--          <v-layout>-->
<!--            <v-btn color="primary" dark text  @click="checkRealPrice()">查詢實撥金額</v-btn>-->
<!--          </v-layout>-->
          <v-layout mt-2></v-layout>
          <v-layout v-if="findCaseType(itemDetail.productId) === '代償'
          || findCaseType(itemDetail.productId) === '借新'">
            <v-flex md6 xs6>
              <h3>前貸一撥金額</h3>
              <v-text-field v-model="item.originAmount" label="前貸金額" type="number" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <v-checkbox
                v-model="item.isPaid"
                label="是否已撥款"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>銀行名稱</h3>
<!--              <v-text-field v-model="item.bankName" label="銀行名稱" outline></v-text-field>-->
              <v-autocomplete :items="getBankInfo"
                              item-text="branch"
                              item-value="key"
                              v-model="item.bankId"
                              :label="`銀行名稱`"
                              outline
              ></v-autocomplete>
            </v-flex >
            <v-flex md6 xs6>
              <h3>分行名稱</h3>
              <v-autocomplete :items="getBankSubInfo"
                              item-text="branch"
                              item-value="code"
                              v-model="item.bankSubId"
                              label="分行名稱"
                              outline
              ></v-autocomplete>
<!--              <v-text-field v-model="item.bankSubName" label="分行名稱" outline></v-text-field>-->
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>戶名</h3>
              <v-text-field v-model="item.bankAccountName" label="戶名" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <h3>帳號</h3>
              <v-text-field v-model="item.bankAccount" label="帳號" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <v-text-field v-model="item.userTransferFee" label="匯費" type="number" outline></v-text-field>
            </v-flex>
            <v-flex md6 xs6>
              <v-btn color="primary" dark text @click="showBankDialog('normal')">常用帳號</v-btn>
            </v-flex >
          </v-layout>
          <hr/>
          <v-layout mt-2></v-layout>
          <h3> 代墊款明細 </h3>
          <v-layout>
            <v-flex md6 xs6>
              <v-text-field v-model="item.amount" label="代墊金額" type="number" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <v-text-field v-model="item.fee" label="代墊手續費(1%)" type="number" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <v-text-field v-model="item.padTransferFee" label="代墊匯費" type="number" outline></v-text-field>
            </v-flex>
            <v-flex md6 xs6>
              <v-text-field v-model="item.pad" label="代墊總額" type="number" outline></v-text-field>
            </v-flex >
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>代墊銀行名稱</h3>
              <v-autocomplete :items="getPadBankInfo"
                              item-text="branch"
                              item-value="key"
                              v-model="item.padBankId"
                              :label="`代墊銀行名稱`"
                              outline
              ></v-autocomplete>
            </v-flex >
            <v-flex md6 xs6>
              <h3>代墊分行名稱</h3>
              <v-autocomplete :items="getPadBankSubInfo"
                              item-text="branch"
                              item-value="code"
                              v-model="item.padBankSubId"
                              label="分行名稱"
                              outline
              ></v-autocomplete>
              <!--              <v-text-field v-model="item.bankSubName" label="分行名稱" outline></v-text-field>-->
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>戶名</h3>
              <v-text-field v-model="item.padBankAccountName" label="戶名" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <h3>帳號</h3>
              <v-text-field v-model="item.padBankAccount" label="帳號" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex md6 xs6>
            <v-btn color="primary" dark text @click="showBankDialog('pad')">常用帳號</v-btn>
          </v-flex >
          <hr/>
          <v-layout mt-2></v-layout>
          <h3> 代扣費用明細 </h3>
          <div>
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.padFee" label="通路服務費" type="number" outline></v-text-field>
              </v-flex>
              <v-flex md6 xs6>
                <v-text-field v-model="item.ticketPrice" label="其他費用" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.settingPrice" label="動保設定費" type="number" outline></v-text-field>
              </v-flex>
              <v-flex md6 xs6>
                <v-text-field v-model="item.transferFee" label="匯款費用(15元)" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
<!--            <v-layout>-->
<!--              <v-flex md6 xs6>-->
<!--                <v-text-field v-model="item.transferFee2" label="匯款費用2" type="number" outline></v-text-field>-->
<!--              </v-flex >-->
<!--              <v-flex md6 xs6>-->
<!--                <v-text-field v-model="item.transferFee3" label="匯款費用3" type="number" outline></v-text-field>-->
<!--              </v-flex >-->
<!--            </v-layout>-->
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.total" label="代扣費用總額" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <h3>代扣銀行名稱</h3>
                <v-autocomplete :items="getWithholdingBankInfo"
                                item-text="branch"
                                item-value="key"
                                v-model="item.withholdingBankId"
                                :label="`代扣銀行名稱`"
                                outline
                ></v-autocomplete>
              </v-flex >
              <v-flex md6 xs6>
                <h3>代扣分行名稱</h3>
                <v-autocomplete :items="getWithholdingBankSubInfo"
                                item-text="branch"
                                item-value="code"
                                v-model="item.withholdingBankSubId"
                                label="代扣分行名稱"
                                outline
                ></v-autocomplete>
                <!--              <v-text-field v-model="item.bankSubName" label="分行名稱" outline></v-text-field>-->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <h3>戶名</h3>
                <v-text-field v-model="item.withholdingBankAccountName" label="戶名" outline></v-text-field>
              </v-flex >
              <v-flex md6 xs6>
                <h3>帳號</h3>
                <v-text-field v-model="item.withholdingBankAccount" label="帳號" outline></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <v-btn color="primary" dark text @click="showBankDialog('withholding')">常用帳號</v-btn>
              </v-flex >
            </v-layout>
          </div>
          <v-layout>
            <v-btn color="primary" dark text  @click="showSecondInfo = !showSecondInfo">增加代墊資料</v-btn>
          </v-layout>
          <div v-if="showSecondInfo">
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.secondPadFee" label="通路服務費" type="number" outline></v-text-field>
              </v-flex>
              <v-flex md6 xs6>
                <v-text-field v-model="item.secondTicketPrice" label="其他費用" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.secondSettingPrice" label="動保設定費" type="number" outline></v-text-field>
              </v-flex>
              <v-flex md6 xs6>
                <v-text-field v-model="item.secondTransferFee" label="匯款費用1(30元)" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <v-text-field v-model="item.secondTotal" label="代扣費用總額" type="number" outline></v-text-field>
              </v-flex >
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <h3>代扣銀行名稱</h3>
                <v-autocomplete :items="getWithholdingBankInfo2"
                                item-text="branch"
                                item-value="key"
                                v-model="item.withholdingBankId2"
                                :label="`代扣銀行名稱`"
                                outline
                ></v-autocomplete>
              </v-flex >
              <v-flex md6 xs6>
                <h3>代扣分行名稱</h3>
                <v-autocomplete :items="getWithholdingBankSubInfo2"
                                item-text="branch"
                                item-value="code"
                                v-model="item.withholdingBankSubId2"
                                label="代扣分行名稱"
                                outline
                ></v-autocomplete>
                <!--              <v-text-field v-model="item.bankSubName" label="分行名稱" outline></v-text-field>-->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 xs6>
                <h3>戶名</h3>
                <v-text-field v-model="item.withholdingBankAccountName2" label="戶名" outline></v-text-field>
              </v-flex >
              <v-flex md6 xs6>
                <h3>帳號</h3>
                <v-text-field v-model="item.withholdingBankAccount2" label="帳號" outline></v-text-field>
              </v-flex>
            </v-layout>

            <v-flex md6 xs6>
              <v-btn color="primary" dark text @click="showBankDialog('withholding2')">常用帳號</v-btn>
            </v-flex >
          </div>

          <hr/>
          <v-layout mt-2></v-layout>
          <v-layout>
            <v-btn color="primary" dark text  @click="setAmount()">計算總額</v-btn>
          </v-layout>

          <h3> 總計 </h3>
          <v-layout>
            <v-flex md3 xs12>
              <v-text-field v-model="item.realAmount" label="實撥金額" type="number" outline></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout v-if="findCaseType(itemDetail.productId) === '代償'
          || findCaseType(itemDetail.productId) === '借新'">

            <v-flex md6 xs6>
              <h5>一撥時間</h5>
              <date-picker :date.sync="item.payTime1" :dateString="item.payTime1" />
              <!--              <v-text-field v-model="item.payTime1" label="一撥時間" outline></v-text-field>-->
            </v-flex >
            <v-flex md6 xs6>
              <h5>二撥時間</h5>
              <date-picker :date.sync="item.payTime2" :dateString="item.payTime2" />
              <!--              <v-text-field v-model="item.payTime2" label="二撥時間" outline></v-text-field>-->
            </v-flex>
          </v-layout>

          <v-layout>
            <v-btn color="primary" dark text  @click="showUploadDialog = true">檔案上傳</v-btn>
          </v-layout>
          <v-layout column v-if="item.fileURL && item.fileURL !==''">
            <span v-if="item.fileURL && item.fileURL !==''">{{ item.fileURL }}</span>
            <span v-if="item.fileURL2 && item.fileURL2 !==''">{{ item.fileURL2 }}</span>
            <span v-if="item.fileURL3 && item.fileURL3 !==''">{{ item.fileURL3 }}</span>
          </v-layout>
        </div>

        <v-layout>
          <v-flex>
            <span style="color: red;">{{ message }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions v-if="itemDetail">
        <v-btn color="primary" text  :loading="saveLoading" @click="saveSetting()">儲存</v-btn>
<!--        <v-btn color="red" dark text @click="closeEvent">取消</v-btn>-->
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :show-cancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    >
    </alert-view>

    <BankListDialog :visible="bankDialog.visible" :tag="bankDialog.tag" @confirmEvent="applyBankEvent" @cancelEvent="bankDialog.visible = false"></BankListDialog>

  </v-container>
</template>

<script>
import DatePicker from "@/components/DatePicker";
import { mapActions, mapGetters } from 'vuex';
import { formatDate } from '@/pages/utils/tool';
import AlertView from '@/components/AlertView';
import { fetchFinanceCreditInfo, getFinanceOfficialData, getFinanceSimpleInfo } from '@/store/actions';
import common from '@/mixins/common';
import BankListDialog from '@/pages/web/BankListDialog';
import UploadDialog from '@/components/UploadDialog';
const bankCodeList = require('../../assets/bank_data.json');
export default {
  name: 'AppropriationEditView',
  components: {
    BankListDialog,
    DatePicker, AlertView, UploadDialog
  },
  mixins:[common],
  data() {
    return {
      showUploadDialog: false,
      bankCopyList: JSON.parse(JSON.stringify(bankCodeList)),
      bankDialog:{
        visible: false,
        tag: ''
      },
      item: {
        displayId: '',
        originAmount: '0',
        beforePercent: '',
        beforePrice: 0,
        beforeBonus: '',
        afterBonus: '',
        name: '',
        memberId: '',
        userTransferFee: 15,
        amount: '',
        fee: '',
        padTransferFee: 30,
        pad: '',
        padFee: '',
        ticketPrice: '',
        settingPrice: '',
        total:'',
        realAmount: '',
        payTime1: '',
        payTime2: '',
        isPaid: false,
        createdDate: new Date(),
        updatedDate: new Date(),
        transferFee: 15,
        transferFee2: '',
        transferFee3: '',
        bankId: '',
        bankSubId: '',
        bankName:'',
        bankSubName: '',
        bankAccountName: '',
        bankAccount:'',
        approvedPrice: 0,
        padBankId:'', // 代墊
        padBankSubId:'', // 代墊
        padBankName:'', // 代墊
        padBankAccountName:'', // 代墊
        padBankAccount: '',
        withholdingBankId: '', // 代扣
        withholdingBankSubId: '', // 代扣
        withholdingBankName: '', // 代扣
        withholdingBankAccountName: '', // 代扣
        withholdingBankAccount: '', // 代扣
        secondPadFee: 0,
        secondTicketPrice: 0,
        secondSettingPrice: 0,
        secondTransferFee: 0,
        secondTransferFee2: 0,
        secondTransferFee3: 0,
        secondTotal: 0,
        withholdingBankId2:'',
        withholdingBankSubId2: '',
        withholdingBankName2:'',
        withholdingBankAccountName2: '',
        withholdingBankAccount2:'',
        fileURL: '',
        fileURL2: '',
        fileURL3: '',
      },
      showSecondInfo: false,
      loading: false,
      saveLoading: false,
      isVisible: false,
      message: '',
      info: null,
      detailInfo: null,
      mode: 'add',
      itemDetail: null,
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      tipCount: 0,
      saveBank: false,
      saveBank1: false,
    }
  },
  watch: {
    visible(value) {
      console.log(`show = ${value}`);
      this.message = '';
      this.isVisible = value;
    },
    isVisible(value) {
      if (!value) {
        this.closeEvent()
      }
    },
    async itemDetail(value) {
      console.log(`itemDetail  = ${JSON.stringify(value)}`);
      if (value){
        this.item.displayId = value.displayId;
        this.item.name = value.name;
        this.item.memberId = value.memberId;
        this.item.approvedPrice = value.totalPrice;
        this.loadData();
      }
    },
    'item.amount'(value){
      if (value && value!==''){
        const fee = Math.round(parseInt(value) * (1 / 100));
        console.log(`代墊手續費 ${value} | ${fee}`);
        if (fee > 0 && fee < 1000){
          this.item.fee = 1000;
        } else{
          this.item.fee = fee;
        }
        this.item.pad = parseInt(value) + parseInt(this.item.fee ? this.item.fee: 0) + parseInt(this.item.padTransferFee);
        this.$forceUpdate();
      }
    },
    'item.fee'(value){
      if (value && value!==''){
        if (this.item){
          this.item.pad =  parseInt(this.item.amount ? this.item.amount: 0) + parseInt(value);
        }
      }
    },
    'item.bankId'(value){
      if (value && this.item){
        const bankInfo = this.bankCopyList[value];
        this.item.bankName = bankInfo.branch;
        console.log(`bankId = ${value} | bankName = ${this.item.bankName}`);
        if (value === '013'){ // 國泰免匯費
          this.item.userTransferFee = 0;
        }
      }
    },
    'item.bankSubId'(value){
      console.log(`bankSubId  = ${value}`);
      if (value && this.item && this.item.bankId){
        const bankInfo = this.bankCopyList[this.item.bankId];
        const find = bankInfo.child.find(b=>b.code === `${this.item.bankId}${value}`);
        console.log(`bankInfo.child  = ${JSON.stringify(bankInfo.child)}`);
        if (find){
          this.item.bankSubName = find.branch;
          console.log(`bankSubName  = ${this.item.bankSubName}`);
        }
      }
    },
    'item.withholdingBankId'(value){
      if (value === '013'){ // 國泰免匯費
        this.item.transferFee = 0;
      }
    },
    'item.withholdingBankId2'(value){
      if (value === '013'){ // 國泰免匯費
        this.item.secondTransferFee = 0;
      }
    },
  },
  computed:{
    ...mapGetters(["getUserInfo"]),
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.item.bankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    getPadBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getPadBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.item.padBankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    getWithholdingBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.item.withholdingBankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    getWithholdingBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getWithholdingBankSubInfo2(){
      let list = [];
      let bankInfo = bankCodeList[this.item.withholdingBankId2];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    getWithholdingBankInfo2(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
  },
  methods: {
    ...mapActions(['loadAppropriationInfo', 'createAppropriationInfo', 'updateAppropriationInfo','getFinanceSimpleInfo', 'getFinanceOfficialData']),
    showBankDialog(tag) {
      this.bankDialog.tag = tag;
      this.bankDialog.visible = true;
    },
    getCaseTitle(promotionType){
      if (promotionType === 'AA21'){
        return '專案原車：代墊前代金額'
      }
      return '前貸一撥金額'
    },
    findCaseType(productId){
      console.log(`findCaseType = ${productId}`);
      const find = this.getSampleCaseTypeList.find(i=>i.key === productId);
      if (find){
        return find.value;
      }
      return '查無分類';
    },
    findCategory(promotionNo, promotionType){
      const find = this.getFinanceCaseViewList.find(i=>i.key === promotionNo && i.busType === promotionType);
      if (find){
        return find.text;
      }
      return '查無分類';
    },
    findStatus(status){
      const find = this.getCaseStatusList.find(i=>i.key === status);
      if (find){
        return find.value;
      }
      return '查無狀態';
    },
    async searchEvent(){
      if (!this.item.displayId || this.item.displayId === ''){
        this.showMessageDialog('錯誤', '請輸入案件編號', true);
        return;
      }
      this.loading = false;
      const res = await this.getFinanceSimpleInfo({ searchValue: this.item.displayId});
      this.saveLoading = false;
      const result = res.data;
      if (result && result.statusCode === 0){
        if (result.data){
          this.itemDetail = result.data;
        } else {
          this.showMessageDialog('錯誤', '找不到案件資料', true);
        }
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message: '找不到資料', true);
      }
    },
    setTotal(){
      const n2 = parseInt(this.item.padFee ? this.item.padFee : 0);
      const n3 = parseInt(this.item.ticketPrice ? this.item.ticketPrice : 0);
      const n4 = parseInt(this.item.settingPrice ? this.item.settingPrice : 0);
      const n5 = parseInt(this.item.transferFee ? this.item.transferFee : 0);

      this.item.total = n2 + n3 + n4 - n5;
      console.log(`setTotal = ${this.item.total} | ${n2} | ${n3} | ${n4}  | ${n5}`);
    },
    setSecondTotal(){
      const n2 = parseInt(this.item.secondPadFee ? this.item.secondPadFee : 0);
      const n3 = parseInt(this.item.secondTicketPrice ? this.item.secondTicketPrice : 0);
      const n4 = parseInt(this.item.secondSettingPrice ? this.item.secondSettingPrice : 0);
      const n5 = parseInt(this.item.secondTransferFee ? this.item.secondTransferFee : 0);
      this.item.secondTotal = n2 + n3 + n4 - n5;
      console.log(`secondTotal = ${this.item.secondTotal} | ${n2} | ${n3} | ${n4}  | ${n5}`);
    },
    setBeforePrice(){
      this.item.beforePrice = this.getBeforePrice(this.itemDetail);
    },
    setAmount(){
      this.setTotal();
      this.setSecondTotal();
      const n1 = parseInt(this.itemDetail.totalPrice ? this.itemDetail.totalPrice : 0);
      this.setBeforePrice();
      // 前貸金額
      const n2 = parseInt(this.item.originAmount ? this.item.originAmount : 0);

      const n20_1 = parseInt(this.item.padFee ? this.item.padFee : 0);
      const n20_2 = parseInt(this.item.ticketPrice ? this.item.ticketPrice : 0);
      const n20_3 = parseInt(this.item.settingPrice ? this.item.settingPrice : 0);

      const n30_1 = parseInt(this.item.secondPadFee ? this.item.secondPadFee : 0);
      const n30_2 = parseInt(this.item.secondTicketPrice ? this.item.secondTicketPrice : 0);
      const n30_3 = parseInt(this.item.secondSettingPrice ? this.item.secondSettingPrice : 0);

      const n2_1 = parseInt(this.item.pad ? this.item.pad : 0);
      const n3_0 = parseInt(this.item.userTransferFee ? this.item.userTransferFee : 0);
      const outPrice = (parseInt(this.item.beforePrice) + n2 + n20_1 + n20_2 + n20_3 + n30_1 + n30_2 + n30_3 + n2_1 + n3_0);
      this.item.realAmount = n1 - outPrice;
      console.log(`setAmount ${n1} - ${outPrice} = ${this.item.realAmount}`);
    },
    async loadData() {
      const res = await this.loadAppropriationInfo({ displayId: this.item.displayId });
      const result = res.data;
      this.info = result.data;

      const detail = await this.getFinanceOfficialData({ caseId: this.itemDetail.caseId});
      if (detail){
        this.detailInfo = detail;

        // this.item.bankId = this.detailInfo.bankId;
        // this.item.bankSubId =  this.detailInfo.bankSubId;
        this.item.bankAccountName = this.itemDetail.name;
        this.item.bankAccount = this.detailInfo.bankAccount;
        console.log(`set bank = ${JSON.stringify(this.detailInfo)}`);
      }

      this.setBeforePrice();

      if (!this.info){
        this.mode = 'add';
      } else {
        this.mode = 'edit';
        this.item = result.data;
        console.log(`loadAppropriationInfo item = ${JSON.stringify(this.item)}`);
        this.item.pad = parseInt(this.item.amount) + parseInt(this.item.fee) + parseInt(this.item.padTransferFee);
        this.$forceUpdate();
      }

    },
    checkRealPrice(){

    },
    async saveSetting() {

      if (this.item.amount === ''){
        this.item.amount = 0;
      }
      if (this.item.fee === ''){
        this.item.fee = 0;
      }
      if (this.item.pad === ''){
        this.item.pad = 0;
      }
      if (this.item.padFee === ''){
        this.item.padFee = 0;
      }
      if (this.item.ticketPrice === ''){
        this.item.ticketPrice = 0;
      }
      if (this.item.settingPrice === ''){
        this.item.settingPrice = 0;
      }
      if (this.item.payTime1 === ''){
        this.item.payTime1 = null;
      }
      if (this.item.payTime2 === ''){
        this.item.payTime2 = null;
      }
      if (this.item.transferFee === ''){
        this.item.transferFee = 0;
      }
      if (this.item.transferFee2 === ''){
        this.item.transferFee2 = 0;
      }
      if (this.item.transferFee3 === ''){
        this.item.transferFee3 = 0;
      }

      if (this.item.beforeBonus === ''){
        this.item.beforeBonus = 0;
      }

      if (this.item.beforePrice === ''){
        this.item.beforePrice = 0;
      }

      if (this.item.afterBonus === ''){
        this.item.afterBonus = 0;
      }

      if (this.item.beforePercent === ''){
        this.item.beforePercent = 0;
      }

      if (this.item.userTransferFee === ''){
        this.item.userTransferFee = 0;
      }

      if (this.item.padTransferFee === ''){
        this.item.padTransferFee = 0;
      }

      if (this.item.realAmount === ''){
        this.item.realAmount = 0;
        this.showMessageDialog('提醒',  `請先計算實撥金額！`, true);
        return;
      }

      console.log(`${this.item.bankAccount} | ${this.detailInfo.bankAccount}`)
      if (this.item.bankAccount !== this.detailInfo.bankAccount){
        if (this.tipCount === 0){
          this.showMessageDialog('提醒',  `匯款帳戶與原本進件資料不同！如確認無誤請再按一次儲存。`, true);
          this.tipCount += 1;
          return;
        }
      }

      this.saveLoading = true;

      let res;
      if (this.mode === 'add'){
        res = await this.createAppropriationInfo(this.item);
      } else {
        res = await this.updateAppropriationInfo(this.item);
      }
      this.saveLoading = false;
      this.tipCount = 0;
      const result = res.data;
      console.log(`save Appropriation result =  ${JSON.stringify(result)}`);

      if (result && result.statusCode === 0){
        this.showMessageDialog('成功', '儲存成功', true);
        this.resetEvent();
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message: '儲存失敗', true);
      }
    },
    resetEvent() {
      this.itemDetail = null;
      this.item = {
        displayId: '',
        originAmount: '0',
        beforePercent: '',
        beforePrice: 0,
        beforeBonus: '',
        afterBonus: '',
        name: '',
        memberId: '',
        userTransferFee: 15,
        amount: '',
        fee: '',
        padTransferFee: 30,
        pad: '',
        padFee: '',
        ticketPrice: '',
        settingPrice: '',
        total:'',
        realAmount: '',
        payTime1: '',
        payTime2: '',
        isPaid: false,
        createdDate: new Date(),
        updatedDate: new Date(),
        transferFee: 15,
        transferFee2: '',
        transferFee3: '',
        bankId: '',
        bankSubId: '',
        bankName:'',
        bankSubName: '',
        bankAccountName: '',
        bankAccount:'',
        approvedPrice: 0,
        padBankId:'', // 代墊
        padBankSubId:'', // 代墊
        padBankName:'', // 代墊
        padBankAccountName:'', // 代墊
        padBankAccount: '',
        withholdingBankId: '', // 代扣
        withholdingBankSubId: '', // 代扣
        withholdingBankName: '', // 代扣
        withholdingBankAccountName: '', // 代扣
        withholdingBankAccount: '', // 代扣
        secondPadFee: 0,
        secondTicketPrice: 0,
        secondSettingPrice: 0,
        secondTransferFee: 0,
        secondTransferFee2: 0,
        secondTransferFee3: 0,
        secondTotal: 0,
        withholdingBankId2:'',
        withholdingBankSubId2: '',
        withholdingBankName2:'',
        withholdingBankAccountName2: '',
        withholdingBankAccount2:'',
        fileURL: '',
        fileURL2: '',
        fileURL3: '',
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    applyBankEvent(option){
      if (option.tag === 'normal'){
        this.item.bankId = option.item.bankId;
        this.item.bankName = option.item.bankName;
        this.item.bankSubId = option.item.bankSubId;
        this.item.bankAccount = option.item.bankAccount;
        this.item.bankAccountName = option.item.accountName;
      } else  if (option.tag === 'pad'){
        this.item.padBankId = option.item.bankId;
        this.item.padBankName = option.item.bankName;
        this.item.padBankSubId = option.item.bankSubId;
        this.item.padBankAccount = option.item.bankAccount;
        this.item.padBankAccountName = option.item.accountName;
      } else if (option.tag === 'withholding'){
        this.item.withholdingBankId = option.item.bankId;
        this.item.withholdingBankName = option.item.bankName;
        this.item.withholdingBankSubId = option.item.bankSubId;
        this.item.withholdingBankAccount = option.item.bankAccount;
        this.item.withholdingBankAccountName = option.item.accountName;
      } else if (option.tag === 'withholding2'){
        this.item.withholdingBankId2 = option.item.bankId;
        this.item.withholdingBankName2 = option.item.bankName;
        this.item.withholdingBankSubId2 = option.item.bankSubId;
        this.item.withholdingBankAccount2 = option.item.bankAccount;
        this.item.withholdingBankAccountName2 = option.item.accountName;
      }
      this.bankDialog.visible = false;
    },
    async uploadFinish(list){
      console.log(`uploadFinish = ${list}`);
      this.showUploadDialog = false;
      const url = list[0].data
      this.item.fileURL = url;

      if (list.length > 1 ){
        this.item.fileURL2 = list[1].data;
      }
      if (list.length > 2 ){
        this.item.fileURL3 = list[2].data;
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/AppropriationEditView.vue